import { render } from "./webhooks.vue?vue&type=template&id=03140b66&scoped=true"
import script from "./webhooks.vue?vue&type=script&lang=js"
export * from "./webhooks.vue?vue&type=script&lang=js"

import "./webhooks.vue?vue&type=style&index=0&id=03140b66&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03140b66"]])

export default __exports__